module.exports = "/static/assets/8093f11e854fdbb07b3a3eafdceeaa53.svg";